import styled from "styled-components";
import { theme } from "@themes";

export const GeneralContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  overflow-y: auto;
  border-top: 1px solid ${({ theme }) => theme.neutral.gray[600]};
`;

export const CategoryContainer = styled.div`
  width: 90%;
  min-height: 44px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  align-items: center;
  display: flex;
  position: relative;

  label {
    color: ${({ theme }) => theme.text.primary};
    font-weight: 400;
    font-size: 14px;
    margin-left: 10px;
  }
  svg {
    position: absolute;
    right: 5px;
    cursor: pointer;
  }
`;
